module.exports = __webpack_public_path__ + "ae821568381f10f5b0f7e6ce42975bca.svg";